import axios from 'axios';
import { fetchCdnData } from '../../helpers/api/auth';
import {
    convertStrToLowerCase,
    formatDisplayUrl,
    replaceHyphenWithSpace,
    replaceHyphenWithUnderscore,
    replaceSpacewithHyphen,
    titleCase,
} from './helper';
import { DATA } from './models/data';

// base CDN url
const cdnUrl = `https://cdn.siberian.dev/code/mapping.json`;

//
const API_URL = process.env.REACT_APP_API_URL;

// fetch CDN mappings
export const fetchData = () => {
    return axios
        .get(cdnUrl)
        .then((res) => {
            // console.log(res);
            return res.data;
        })
        .catch((err) => console.error(err));
};

// returns array of models
export const getModels = (data, modelName) => {
    // console.log(data, modelName);
    return new Promise((resolve, reject) => {
        var models = [];

        data.forEach((el1) => {
            if (el1.name.toLowerCase() === replaceHyphenWithUnderscore(modelName).toLowerCase()) {
                models = el1.models;
                resolve(models);
            }
        });
        if (models.length === 0) {
            reject('no models found');
        }
    });
};

// get SEO details for models page
export const getModelsSeoDetails = (data, modelName) => {
    return new Promise((resolve, reject) => {
        // const modelname = titlecase(modelName);
        // if(data[modelname])

        data.map((el1) => {
            if (el1.name.toLowerCase() === replaceHyphenWithUnderscore(modelName)) {
                const result = {
                    modelName: modelName,
                    description: el1.description,
                };
                resolve(result);
            }
        });
    });
};

//get SEO details based on problem and model
export const getSeoDetails = (data, problemName, modelName) => {
    // console.log('GET SEO DETAILS CALLED.');
    // console.log(data, problemName, modelName);
    const page1 = data.page1;
    const page2 = data.page2;
    // console.log(page2);

    return new Promise((resolve, reject) => {
        if (problemName && !modelName) {
            page1.forEach((ele) => {
                // console.log(convertStrToLowerCase(replaceSpacewithHyphen(ele.name)), problemName);
                if (convertStrToLowerCase(replaceSpacewithHyphen(ele.name)) === problemName) {
                    const result = {
                        title: ele.name,
                        description: ele.description,
                    };
                    // console.log('RESSULT IS -> ', result);
                    resolve(result);
                }
            });
        }
        if (problemName && modelName) {
            // console.log(page2);
            // console.log('Check Prop ', titleCase(replaceHyphenWithSpace(problemName)));
            // console.log('check bool ', page2.hasOwnProperty(titleCase(replaceHyphenWithSpace(problemName))));

            if (page2.hasOwnProperty(titleCase(replaceHyphenWithSpace(problemName)))) {
                // console.log('in if');
                page2[titleCase(replaceHyphenWithSpace(problemName))].forEach((ele) => {
                    // console.log(convertStrToLowerCase(replaceSpacewithHyphen(ele.name)), modelName);
                    if (convertStrToLowerCase(replaceSpacewithHyphen(ele.name)) === modelName) {
                        const result = {
                            title: titleCase(replaceHyphenWithSpace(problemName)),
                            description: ele.description,
                        };
                        // console.log('RESSULT IS -> ', result);
                        resolve(result);
                    }
                });
            }
        }
    });
};

// returns *.ipynb file URL
export const getFileUrl = (modelList, modelName, subModelName) => {
    return new Promise((resolve, reject) => {
        modelList.map((m) => {
            m.models.map((model) => {
                if (formatDisplayUrl(model.display_url) === `${modelName}/${subModelName}`) {
                    const url = model.URL;
                    resolve(url);
                }
            });
        });
    });
};

// fetch *.ipynb file data in json format
export const getFileData = (url) => {
    return axios
        .get(url)
        .then((res) => res.data)
        .catch((err) => console.log(err));
};

// downloads *.ipynb file
export const exportData = (fileData, subModelName) => {
    const jsonString = `data:text/json;chatset=utf-8,${encodeURIComponent(JSON.stringify(fileData))}`;
    const link = document.createElement('a');
    link.href = jsonString;
    link.download = `${subModelName}.ipynb`;
    link.click();
};

// donwload *.ipynb file helper funtion
export const handleDonwnload = async (url, subModelName) => {
    const fileData = await getFileData(url);
    await exportData(fileData, subModelName);
};

// donwload *.ipynb file helper function2
export const handleDonwnload2 = async (modelName, subModelName) => {
    // const data = await fetchData().catch((err) => console.log(err));
    const data = await fetchNewMapData().catch((err) => console.log(err));
    const modelList = await getModels(data, modelName).catch((err) => console.log(err));
    const url = await getFileUrl(modelList, modelName, subModelName).catch((err) => console.log(err));
    const fileData = await getFileData(url).catch((err) => console.log(err));
    await exportData(fileData, subModelName);
};

/////////////////////////////NEW MAP.json TESTING//////////////////////////////////////////////////////////
export const fetchNewMapData = () => {
    return axios
        .get(`${API_URL}/get-all/mappings`)
        .then((response) => {
            // console.log(response);
            return response.data.mappings;
        })
        .catch((err) => console.error(err));
};

export const isRenderToCodeGen = (templates) => {
    if (templates.model) {
        return false;
    }
    return true;
};

export const getNewModelsData = (data, modelName, page) => {
    // console.log(data, modelName);

    // console.log(Object.keys(data));

    return new Promise((resolve, reject) => {
        Object.keys(data).map((key) => {
            switch (page) {
                case 'page1':
                    resolve(data[page]);
                    break;
                case 'page2':
                    // console.log(data[page]);
                    if (data[page][modelName] === undefined) return reject('no models found');
                    else {
                        const response = [];
                        response.push(data);
                        let mappingObj = {};

                        response.map((ele, i) => {
                            ele.page1.forEach((el) => {
                                if (el.name === modelName) {
                                    mappingObj = {
                                        ...mappingObj,
                                        page1: {
                                            name: el.name,
                                            description: el.description,
                                            image: el.image,
                                            model: el.model,
                                        },
                                    };
                                }
                            });
                            if (ele.page2.hasOwnProperty(modelName)) {
                                // const key = `${modelName}`;
                                mappingObj = {
                                    ...mappingObj,
                                    page2: { modelName: modelName, models: ele.page2[modelName] },
                                };
                            }
                            mappingObj = { ...mappingObj, page3: ele.page3, displayMap: ele.displayMap };
                        });
                        resolve(mappingObj);
                    }
                    break;
                default:
            }
        });
    });
};

// export const saveLogs = (st, page, value) => {};
